/** Material UI Packages. */
import { Box, Chip, Fade, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

/** Material UI Icons. */
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditNoteIcon from '@mui/icons-material/EditNote';

export default function ApplySettingHeader(props) {
    /** Get props from ApplySetting.js. */
    const { mode, applySettingData, handleModeChange } = props;

    /** Chip icon mapper for current mode. */
    const modeGroup = {
        create: {
            icon: <AddCircleOutlineIcon fontSize="small" />,
            label: 'Create Mode',
        },
        edit: {
            icon: <EditIcon fontSize="small" />,
            label: 'Edit Mode',
        },
        note: {
            icon: <EditNoteIcon fontSize="small" />,
            label: 'Note Mode',
        },
    };

    /** Function to check empty data. */
    const isDataEmpty = Object.keys(applySettingData ?? {}).length === 0;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', height: 30 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography sx={{ color: '#01354d', fontSize: '13px', fontWeight: 500 }}>APPLY SETTING</Typography>
                {mode !== 'view' && (
                    <Fade in={mode !== 'view'}>
                        <Chip
                            icon={modeGroup[mode]?.icon ?? null}
                            label={modeGroup[mode]?.label ?? ''}
                            color="primary"
                            sx={{ ml: 2, height: '20px' }}
                        />
                    </Fade>
                )}
            </Box>
            <ToggleButtonGroup value={mode} onChange={handleModeChange} color="primary" exclusive sx={{ height: 20 }}>
                <ToggleButton value="create">Create</ToggleButton>
                <ToggleButton value="edit" disabled={isDataEmpty}>
                    Edit
                </ToggleButton>
                <ToggleButton value="note" disabled={isDataEmpty}>
                    Note
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
}
